import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../../Business/Turnero/Turnero.css';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faSave, faCheck, faPlus, faEdit, faTrash, faLayerGroup } from '@fortawesome/free-solid-svg-icons';

/**
 * SpecialtyABM - CRUD for Specialties (Especialidades)
 */
const SpecialtyABM = ({ ipserv, branch_id }) => {
    const [loading, setLoading] = useState(false);
    const [specialties, setSpecialties] = useState([]);
    const [types, setTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        EspecialidadNombre: '',
        EspecialidadDescripcion: '',
        TipoTurnoId: ''
    });

    const loadData = () => {
        if (!branch_id) return;
        setLoading(true);
        // Load Specialties
        request.Get(ipserv + 'turnero/specialties', { sucursalId: branch_id }, r => {
            if (r.success) setSpecialties(r.data || []);
        });
        // Load Types for linking
        request.Get(ipserv + 'getTurneroTipos', { sucursalId: branch_id }, r => {
            if (r.success) setTypes(r.rows || []);
            setLoading(false);
        });
    };

    useEffect(() => {
        loadData();
    }, [branch_id]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setFormData(item ? {
            ...item
        } : {
            EspecialidadNombre: '',
            EspecialidadDescripcion: '',
            TipoTurnoId: ''
        });
        setShowModal(true);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(ipserv + 'turnero/saveSpecialty', {
            ...formData,
            EspecialidadId: currentItem?.EspecialidadId,
            SucursalId: branch_id
        }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Especialidad guardada correctamente' });
                setShowModal(false);
                loadData();
            } else {
                Notify({ type: 'fail', text: r.msg || 'Error al guardar especialidad' });
            }
            setLoading(false);
        });
    };

    const handleDelete = (id) => {
        if (window.confirm("¿Estás seguro de eliminar esta especialidad?")) {
            request.Post(ipserv + 'turnero/deleteSpecialty', { id }, r => {
                if (r.success) {
                    Notify({ type: 'success', text: 'Especialidad eliminada' });
                    loadData();
                } else {
                    Notify({ type: 'fail', text: r.msg || 'Error al eliminar' });
                }
            });
        }
    };

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Especialidades</h2>
                    <p className="text-muted small">Define las áreas de atención específica para los turnos web y agendados.</p>
                </div>
                <button
                    className="auth-btn-primary"
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
                    onClick={() => handleOpenModal()}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nueva Especialidad
                </button>
            </div>

            <div className="turnero-card p-0 overflow-hidden">
                <table className="table  table-hover m-0">
                    <thead className="">
                        <tr>
                            <th className="border-0 p-3">Nombre</th>
                            <th className="border-0 p-3">Sector / Servicio</th>
                            <th className="border-0 p-3">Descripción</th>
                            <th className="border-0 p-3 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && specialties.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center p-5">
                                    <Spinner animation="border" variant="primary" />
                                </td>
                            </tr>
                        ) : specialties.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center p-5 text-muted">No hay especialidades configuradas</td>
                            </tr>
                        ) : (
                            specialties.map(s => (
                                <tr key={s.EspecialidadId} className="animate-in">
                                    <td className="p-3 font-weight-bold">{s.EspecialidadNombre}</td>
                                    <td className="p-3">
                                        <span className="turnero-badge bg-primary">
                                            <FontAwesomeIcon icon={faTags} className="mr-2 opacity-50" />
                                            {s.TipoNombre || 'Sin asignar'}
                                        </span>
                                    </td>
                                    <td className="p-3 small text-muted">{s.EspecialidadDescripcion}</td>
                                    <td className="p-3 text-center">
                                        <button className="btn btn-sm btn-outline-info mr-2" onClick={() => handleOpenModal(s)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(s.EspecialidadId)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered contentClassName="turnero-card border-0">
                <form onSubmit={handleSave}>
                    <Modal.Body className=" px-4">
                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faLayerGroup} className="mr-2" /> Datos de la Especialidad
                        </div>
                        <Row>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Nombre</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Ej: JUBILACIONES"
                                    value={formData.EspecialidadNombre}
                                    onChange={e => setFormData({ ...formData, EspecialidadNombre: e.target.value.toUpperCase() })}
                                    required
                                />
                            </Col>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Sector (Tipo de Turno)</label>
                                <select
                                    className="turnero-input"
                                    value={formData.TipoTurnoId}
                                    onChange={e => setFormData({ ...formData, TipoTurnoId: e.target.value })}
                                    required
                                >
                                    <option value="">Seleccione un sector...</option>
                                    {types.map(t => (
                                        <option key={t.TipoId} value={t.TipoId}>{t.TipoNombre}</option>
                                    ))}
                                </select>
                            </Col>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Descripción</label>
                                <textarea
                                    className="turnero-input"
                                    style={{ height: '80px', paddingTop: '10px' }}
                                    placeholder="Breve descripción del área..."
                                    value={formData.EspecialidadDescripcion}
                                    onChange={e => setFormData({ ...formData, EspecialidadDescripcion: e.target.value })}
                                />
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="border-0 px-4 pb-4">
                        <button type="button" className="btn btn-link text-muted" onClick={() => setShowModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="turnero-btn turnero-btn-primary px-5" disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : (
                                <><FontAwesomeIcon icon={currentItem ? faSave : faCheck} className="mr-2" /> {currentItem ? 'Actualizar' : 'Crear Especialidad'}</>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};

export default SpecialtyABM;
